import React, { PureComponent } from 'react';
import axios from 'axios';
import { Carousel } from 'react-responsive-carousel';

import { urls } from '../../../services/urls';
import { T } from '../../../../../common/locale/translate';

export default class RecommendedRegions extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      region_categories: []
    };
  }

  componentDidMount() {
    axios({
      method: 'get',
      url: urls['get_recommended_regions'],
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.setState({ region_categories: response.data });
    });
  }

  render() {
    const categories = this.renderCategories();

    return (
      <section className="recommended-regions">
        <h3>{T('recommended_regions_header')}</h3>
        <p>{T('recommended_regions_subheader')}</p>
        <article className="wrapper region-categories-wrapper">
          <div className="desktop">{categories}</div>
          <div className="mobile">
            {this.state.region_categories.length && (
              <Carousel
                className="curiosity-slider"
                showArrows={false}
                showThumbs={false}
                emulateTouch={false}
                showIndicators={true}
                autoPlay={false}
                showStatus={false}
                infiniteLoop={true}
                axis="horizontal"
                stopOnHover={false}
                transitionTime={1000}
                interval={20000}
              >
                {categories}
              </Carousel>
            )}
          </div>
        </article>
      </section>
    );
  }

  renderCategories = () =>
    this.state.region_categories.map(category => (
      <div className="regions-category-wrapper">
        <h3>{T(`recommended_regions_${category.title}`)}</h3>
        <div className="wrapper regions-wrapper">
          {category.regions.map(region => {
            if (!region.min_price_pln) return;
            return (
              <a
                href={region.link}
                className="region-item"
                title={`Region: ${region.name}`}
              >
                <span className="region-name">{region.name}</span>
                <span className="price-wrapper">
                  <span className="region-price-from">{T('price_from')}</span>
                  <span className="region-price-value">
                    {region.min_price_pln}
                  </span>
                  <span className="region-price-currency">
                    {`${T('currency_pln')}${T('per_person')}`}
                  </span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    ));
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/recommended_regions.jsx